module.exports = __webpack_public_path__ + "img/gs.b97c4d63.svg";